import { css } from 'styled-components';
import {
  position,
  PositionProps as SsPositionProps,
  top,
  TopProps,
  right,
  RightProps,
  bottom,
  BottomProps,
  left,
  LeftProps,
  zIndex,
  ZIndexProps
} from 'styled-system';

const positionHelper = css`
  ${position};
  ${top};
  ${right};
  ${bottom};
  ${left};
  ${zIndex};
`;

export interface PositionProps extends SsPositionProps, TopProps, RightProps, BottomProps, LeftProps, ZIndexProps {}

export default positionHelper;
